import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=8c967cf6&scoped=true&lang=pug"
import script from "./Balances.vue?vue&type=script&lang=js"
export * from "./Balances.vue?vue&type=script&lang=js"
import style0 from "./Balances.vue?vue&type=style&index=0&id=8c967cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c967cf6",
  null
  
)

export default component.exports